import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { HashLink } from 'react-router-hash-link';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
export default class Navbars extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navExpanded: false,
      isSticky: false,
      top: window.screen.width < 767 ? 80 : 120,
      fontSize: window.screen.width < 767 ? '10px' : '16px',
    };
  }

  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
  }

  setNavClose = () => {
    this.setState({ navExpanded: false });
  }

  handleScroll = () => {
    const scrollTop = window.scrollY;

    if (window.screen.width < 767) {
      if (scrollTop > 20 && !this.state.isSticky) {
        this.setState({ isSticky: true });
      } else if (scrollTop <= 20 && this.state.isSticky) {
        this.setState({ isSticky: false });
      }
    }
    else {
      if (scrollTop > 20 && !this.state.isSticky) {
        this.setState({ isSticky: true });
      } else if (scrollTop <= 20 && this.state.isSticky) {
        this.setState({ isSticky: false });
      }
    }


  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    // console.log('qqqqqqqqqqqqqqq');
    // console.log(window);
    // console.log(window.screen.width);
    // console.log('qqqqqqqqqqqqqqq');
    // if (window.screen.width < 767) {
    //   this.setState({
    //     fontSize: '10px',
    //     top: 80,
    //   });
    // }
    // else {
    //   this.setState({
    //     fontSize: '16px',
    //     top: 120,
    //   });
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {

    const { isSticky } = this.state;

    let barStyle = {
      position: 'fixed',
      top: isSticky ? 0 : this.state.top,
      width: '100%',
      //backgroundColor: '#C7AD6E',
      backgroundColor: 'rgba(199,173,110, 0.8)',
      color: '#fff',
      textAlign: 'center',
      padding: '1px 0',
      zIndex: 9999999,
      boxShadow: isSticky ? '0 2px 5px rgba(0,0,0,0.2)' : 'none',
      transition: 'all 1s ease-in-out',
     // fontSize: this.state.fontSize,
    };

    // if (window.screen.width < 767) {
    //   barStyle.fontSize = '10px';
    // }

    // if (isSticky) {
    //   barStyle.top = 0;
    // }
    // else {
    //   if (window.screen.width < 767) {
    //     barStyle.top = 80;
    //   }
    //   else {
    //     barStyle.top = 120;
    //   }
    // }

    return (

      <div>

        <Navbar className="navbar-dark" expand="lg" onToggle={this.setNavExpanded} expanded={this.state.navExpanded}>
          <Navbar.Brand as={Link} to={`${process.env.PUBLIC_URL}/`}><LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="" width="120" height="100%" className="img-responsive mblogos" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav navbar-right">
            <Nav className="mr-auto">
              <NavItem>   </NavItem>

            </Nav>

            <Nav onClick={this.setNavClose}>

              {/* <NavLink  as={Link}  to="/Aboutme">About</NavLink>  */}
              {/* <AnchorLink  href="#services" className="nav-link">SERVICES</AnchorLink> */}
              <HashLink to="/#services" className="nav-link">
                SERVICES
              </HashLink>
              <HashLink to="/#footer" className="nav-link">CONTACT US</HashLink>
              {/* <AnchorLink href="#footer" className="nav-link">CONTACT US</AnchorLink> */}
              <Link to={`${process.env.PUBLIC_URL}/work.html`} className="nav-link">WORK</Link>
              <Link to={`${process.env.PUBLIC_URL}/career.html`} className="nav-link">CAREERS</Link>
              <Link to={`${process.env.PUBLIC_URL}/luxury-digital-agency-dubai.html`} className="nav-link">DUBAI</Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div style={barStyle} className="offer-bar">
          <AnchorLink href="#footer" className="nav-link"><p style={{ margin: 0 }}>$1,000 Complimentary Ad Credits for Luxury Brands.</p></AnchorLink>
        </div>

      </div>
    );
  };
}
